class ProductVariantsModal extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger', 'modal', 'close', 'backdrop']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.trigger.element,
      'click',
      this.onTriggerClick.bind(this),
    )

    this.listeners.add(this.els.backdrop.element, 'click', () =>
      this.closeShippingSelect(),
    )

    this.listeners.add(this.els.close.element, 'click', () =>
      this.closeShippingSelect(),
    )
  }

  onTriggerClick () {
    this.els?.modal?.element?.setAttribute('aria-hidden', 'false')

    document.body.classList.add('lyt-Header-modalOpen')
    document.body.style.setProperty('overflow', 'hidden')
  }

  closeShippingSelect () {
    this.els?.modal?.element?.setAttribute('aria-hidden', 'true')

    document.body.classList.remove('lyt-Header-modalOpen')
    document.body.style.removeProperty('overflow', 'hidden')
  }
}

if (!window.customElements.get('product-variants-modal')) {
  window.customElements.define('product-variants-modal', ProductVariantsModal)
}
